/**
 * Справочник «кто за каким стендом» — из ответа карты.
 *
 * Сервер отдаёт его полем `stands` рядом с картой и графом: номер
 * стенда → список компаний. Приходит он вместе с картой, значит номера
 * в нём заведомо от неё — обходить страницы экспонентов и сверять
 * номера больше не нужно.
 *
 * Внутри модуль работает плоским списком: так удобнее и искать, и
 * помечать занятые стенды. Оба источника приводятся к одному виду,
 * чтобы дальше по дороге не различать, откуда справочник взялся.
 */

/** Общий вид записи справочника. */
function normalizeCompany(company, stand) {
  return {
    ident: company.ident ?? company.id ?? null,
    name: company.name || '',
    logo: company.logo || null,
    // модуль, которому компания принадлежит: у партнёра и экспонента
    // свои нумерации, и ошибка здесь открыла бы чужую компанию
    app: company.app || null,
    stand,
  };
}

/**
 * @param {Object|null} stands поле `stands` из ответа карты
 * @returns {Array|null} null, если справочника нет — это не ошибка
 */
export function directoryFromStands(stands) {
  if (!stands || typeof stands !== 'object') return null;

  const flat = Object.entries(stands).flatMap(([stand, companies]) => (
    Array.isArray(companies)
      ? companies.map((company) => normalizeCompany(company, stand))
      : []
  ));

  return flat.length ? flat : null;
}

/**
 * Тот же вид из ответа `/exhibitor/page`. Запасной путь: у мероприятия
 * может ещё не быть поля `stands`. Уйдёт вместе с ним — см. беклог в
 * docs/map-navigation-plan.md.
 */
export function directoryFromExhibitors(list) {
  if (!Array.isArray(list)) return [];
  return list.map((company) => normalizeCompany(company, company.stand || ''));
}
